export default "__VITE_ASSET__bf1a2e7d__"